import React, { useState } from "react";
import GraphData from "@imminently/decisively-ui/GraphData";
import Dialog from "@imminently/decisively-ui/Dialog";
import DropdownMenu from "@imminently/decisively-ui/DropdownMenu";
import { useGraphVisualisation } from "../../hooks/useGraphVisualisation";
import { useFullRelease } from "@/common/hooks_useFullRelease";
import { useEditAttributeModal } from "@/pages/models/release/DataModel/route/Attributes/AttributeEditModal";
import { AttributeHistoryModal } from "@/pages/sessions/components/AttributeHistoryModal";

const Data = ({ session, onGoToInputAndSelectInteraction }) => {
  const { graph, visible, setSelectedNodeId, selectedNodeId, debug } = useGraphVisualisation();
  const release = useFullRelease();
  const openEditModal = useEditAttributeModal();
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyNode, setHistoryNode] = useState(null);

  if (!release) return null;

  const attributePath = historyNode?.path ?? historyNode?.id;

  return (
    <>
      <GraphData
        graph={graph}
        visible={visible}
        release={release}
        debug={debug}
        selectedNodeId={selectedNodeId}
        renderExtraMenuItems={(node) => (
          <>
            <DropdownMenu.Item
              onClick={() => {
                if (node.id) openEditModal(node.id);
              }}
            >
              <DropdownMenu.Item.Label>Edit Metadata</DropdownMenu.Item.Label>
            </DropdownMenu.Item>
            {session?.id && (node.path || node.id) ? (
              <DropdownMenu.Item
                onClick={() => {
                  setHistoryNode(node);
                  setHistoryOpen(true);
                }}
              >
                <DropdownMenu.Item.Label>View history</DropdownMenu.Item.Label>
              </DropdownMenu.Item>
            ) : null}
          </>
        )}
        onSelectNode={(node) => {
          if (node) {
            setSelectedNodeId(node.path || node.id);
          }
        }}
      />
      <Dialog open={historyOpen} onOpenChange={setHistoryOpen}>
        <AttributeHistoryModal
          open={historyOpen}
          onClose={() => setHistoryOpen(false)}
          sessionId={session?.id ?? ""}
          attributePath={attributePath ?? ""}
          attributeLabel={historyNode?.description}
          interactions={session?.interactions}
          onGoToInteraction={onGoToInputAndSelectInteraction}
        />
      </Dialog>
    </>
  );
};
Data.displayName = "components/GraphVisualisation/components/Data";

export default Data;
